/* ISO snow: canvas snowfall for the club shops hero (Christmas mode).
   Finds every [data-iso-snow] canvas; flake count from data-density. */
(function () {
  'use strict';
  if (window.IsoSnow) return;

  var MOBILE_BREAKPOINT = 750;
  var MAX_DPR = 2;
  var instances = [];

  function rand(min, max) { return min + Math.random() * (max - min); }

  function onMqChange(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else mq.addListener(fn);
  }
  function offMqChange(mq, fn) {
    if (mq.removeEventListener) mq.removeEventListener('change', fn);
    else mq.removeListener(fn);
  }

  function Snow(canvas) {
    this.canvas   = canvas;
    this.ctx      = canvas.getContext('2d');
    this.host     = canvas.parentElement;
    this.density  = parseInt(canvas.getAttribute('data-density'), 10) || 140;
    this.reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.flakes   = [];
    this.width    = 0;
    this.height   = 0;
    this.time     = 0;
    this.last     = 0;
    this.raf      = null;
    this.onScreen = true;

    this.tick   = this.tick.bind(this);
    this.resize = this.resize.bind(this);
    this.update = this.update.bind(this);

    var self = this;
    this.resizeObserver = new ResizeObserver(this.resize);
    this.resizeObserver.observe(this.host);
    this.intersectionObserver = new IntersectionObserver(function (entries) {
      self.onScreen = entries[0].isIntersecting;
      self.update();
    });
    this.intersectionObserver.observe(this.host);
    document.addEventListener('visibilitychange', this.update);
    onMqChange(this.reduceMq, this.update);
  }

  Snow.prototype.resize = function () {
    var rect = this.host.getBoundingClientRect();
    var dpr  = Math.min(window.devicePixelRatio || 1, MAX_DPR);
    this.width  = rect.width;
    this.height = rect.height;
    this.canvas.width  = Math.round(rect.width * dpr);
    this.canvas.height = Math.round(rect.height * dpr);
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.seed();
    this.draw();
    this.update();
  };

  Snow.prototype.seed = function () {
    var count = this.density;
    if (window.innerWidth < MOBILE_BREAKPOINT) count = Math.round(count / 2);
    this.flakes = [];
    for (var i = 0; i < count; i++) {
      var r = rand(1.5, 4);
      this.flakes.push({
        x0:    rand(0, this.width),
        y:     rand(0, this.height),
        r:     r,
        alpha: rand(0.35, 0.8),
        vy:    30 + r * 15,          /* px per second: 52–90, bigger flakes fall faster */
        amp:   rand(4, 14),          /* sway width in px */
        freq:  rand(0.4, 1),         /* sway speed in rad/s */
        phase: rand(0, Math.PI * 2)
      });
    }
  };

  Snow.prototype.draw = function () {
    var ctx = this.ctx;
    ctx.clearRect(0, 0, this.width, this.height);
    ctx.fillStyle = '#f4f4f2';
    for (var i = 0; i < this.flakes.length; i++) {
      var f = this.flakes[i];
      ctx.globalAlpha = f.alpha;
      ctx.beginPath();
      ctx.arc(f.x0 + Math.sin(this.time * f.freq + f.phase) * f.amp, f.y, f.r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
  };

  Snow.prototype.tick = function (now) {
    var dt = Math.min((now - this.last) / 1000, 0.05);
    this.last = now;
    this.time += dt;
    for (var i = 0; i < this.flakes.length; i++) {
      var f = this.flakes[i];
      f.y += f.vy * dt;
      if (f.y - f.r > this.height) {
        f.y  = -f.r;
        f.x0 = rand(0, this.width);
      }
    }
    this.draw();
    this.raf = requestAnimationFrame(this.tick);
  };

  /* Animate only when motion is allowed, the hero is on screen and the tab is visible. */
  Snow.prototype.update = function () {
    var shouldRun = !this.reduceMq.matches && this.onScreen && !document.hidden;
    if (shouldRun && !this.raf) {
      this.last = performance.now();
      this.raf = requestAnimationFrame(this.tick);
    } else if (!shouldRun && this.raf) {
      cancelAnimationFrame(this.raf);
      this.raf = null;
    }
  };

  Snow.prototype.destroy = function () {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = null;
    this.resizeObserver.disconnect();
    this.intersectionObserver.disconnect();
    document.removeEventListener('visibilitychange', this.update);
    offMqChange(this.reduceMq, this.update);
  };

  function init(root) {
    var canvases = (root || document).querySelectorAll('[data-iso-snow]');
    for (var i = 0; i < canvases.length; i++) {
      var canvas = canvases[i];
      if (canvas.isoSnow || !canvas.getContext) continue;
      canvas.isoSnow = new Snow(canvas);
      instances.push(canvas.isoSnow);
    }
  }

  function destroy(root) {
    instances = instances.filter(function (snow) {
      if (!root.contains(snow.canvas)) return true;
      snow.destroy();
      return false;
    });
  }

  document.addEventListener('shopify:section:load',   function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });

  window.IsoSnow = { init: init };
  init(document);
})();
